import React from "react";
import PropTypes from "prop-types";
import { Container } from "./style";

export const CartSummary = ({ children }) => {
  return <Container>{children}</Container>;
};

CartSummary.propTypes = {
  children: PropTypes.node,
};
